module.exports = __webpack_public_path__ + "img/home_1280.8de67128.webp";